import {State} from '.'
import {Action} from './actions'
import {FlowAction} from './slice/flow/actions'
import {flowReducer} from './slice/flow/reducer'

export const reducer = (state: State, action: Action): State => {
  // Note - this relies on the child reducers ignoring unknown actions
  return {
    flow: flowReducer(state.flow, action as FlowAction)
  }
}
